import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomIABCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m5.847-4.386 3.722-1.654a1.06 1.06 0 0 1 .862 0l3.722 1.654c.383.17.633.553.633.974v2.5c0 2.95-2.042 5.71-4.786 6.38-2.744-.67-4.786-3.43-4.786-6.38v-2.5c0-.42.25-.803.633-.974m7.876 4H12v-4.68L8.277 8.588v3.03H12v4.75c1.978-.612 3.44-2.563 3.723-4.754"
  />,
  'CustomIABCircular',
);

export default CustomIABCircular;
